/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Cancel_ConfirmInputs */

const en_settings_billing_cancel_confirm = /** @type {(inputs: Settings_Billing_Cancel_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel subscription`)
};

/**
* | output |
* | --- |
* | "Cancel subscription" |
*
* @param {Settings_Billing_Cancel_ConfirmInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_cancel_confirm = /** @type {((inputs?: Settings_Billing_Cancel_ConfirmInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Cancel_ConfirmInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_cancel_confirm(inputs)
});
export { settings_billing_cancel_confirm as "settings.billing.cancel_confirm" }